export default [
  require('/usr/src/app/node_modules/infima/dist/css/default/default.css'),
  require('/usr/src/app/node_modules/@docusaurus/theme-classic/lib/prism-include-languages'),
  require('/usr/src/app/node_modules/@docusaurus/theme-classic/lib/nprogress'),
  require('/usr/src/app/src/css/custom.scss'),
  require('/usr/src/app/node_modules/docusaurus-theme-openapi-docs/lib/theme/styles.scss'),
  require('/usr/src/app/src/clientModules/docsearchKeydownGuard.js'),
  require('/usr/src/app/src/clientModules/docsearchDrawerHeader.js'),
];
